import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { UserService } from './user.service';

export const ngxUserServiceModule = angular.module('ngxUserServiceModule', [])
	.factory('ngxUserService', downgradeInjectable(UserService) as any)
	.name;
